module.exports = __webpack_public_path__ + "img/onersd.04ab347b.jpg";